import type React from "react";

import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import {
    StyledEnrichmentInstructionsContainer,
    StyledListItem,
} from "app/pages/sales-intelligence/modules/enrichment/components/UploadEnrichmentInstructions/style";
import { CSV_LIMIT_VALUE } from "app/pages/sales-intelligence/modules/enrichment/constants/constants";
import type { EnrichmentType } from "app/pages/sales-intelligence/modules/enrichment/types/types";
import {
    ONE_OF_THE_COLUMN_TEXT,
    MAXIMUM_ROWS_TEXT,
    FIRST_ROW_HEADER_TEXT,
    FOURTH_ROW_HEADER_TEXT,
    LIST_GUIDELINES,
} from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";
import { StyledList } from "app/pages/sales-intelligence/pages/management/components/Management/styles";
import { SL_CONTACTS_IMG_LISTS, SL_IMG_LISTS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import { StyledListImage } from "app/pages/sales-intelligence/sub-modules/management/components/style";
import { formatNumberWithComa } from "app/pages/sales-intelligence/utils/leads";
import { AssetsService } from "app/services/AssetsService";

type Props = {
    type?: EnrichmentType;
};

export const UploadEnrichmentInstructions: React.FC<Props> = ({ type = "company" }) => {
    return (
        <StyledEnrichmentInstructionsContainer>
            <StyledListImage
                src={AssetsService.assetUrl(type === "company" ? SL_IMG_LISTS : SL_CONTACTS_IMG_LISTS)}
                alt="enrichment-list-img"
            />
            <div>
                <Text fontVariant="button">{translate(LIST_GUIDELINES)}</Text>
                <StyledList>
                    <StyledListItem>{translate(ONE_OF_THE_COLUMN_TEXT)}</StyledListItem>

                    <StyledListItem>{translate(MAXIMUM_ROWS_TEXT)}</StyledListItem>
                    <StyledListItem>
                        {translate(FIRST_ROW_HEADER_TEXT, {
                            value: formatNumberWithComa(CSV_LIMIT_VALUE),
                        })}
                    </StyledListItem>
                    <StyledListItem>{translate(FOURTH_ROW_HEADER_TEXT)}</StyledListItem>
                </StyledList>
            </div>
        </StyledEnrichmentInstructionsContainer>
    );
};
